import React from 'react'
import ReactDOM from 'react-dom'
import LogRocket from 'logrocket'
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer'
import { getStore, history } from './store'
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import Actions from './actions'
import { isProduction } from './utils/envUtils'
import { StyleProvider } from '@ant-design/cssinjs'
import App from './components/App'

// STYLES
import './styles/reset-css.css'
import './styles/theme.css'
import './styles/telehealthTheme.css'
import './styles/hmoTheme.css'

// FONT ICON
import './resources/fonts/antidote-v1.0/style.css'

const privateFieldNames = ['password', 'token']
const { requestSanitizer, responseSanitizer } =
  LogrocketFuzzySanitizer.setup(privateFieldNames)

if (isProduction) {
  LogRocket.init('zvveep/sow', {
    network: {
      requestSanitizer,
      responseSanitizer
    },
    mergeIframes: true
  })
  // ReactGA.initialize('G-Q6DWE0KJ99')
  // ReactGA.send('pageview')
} else if (
  window.location.hostname !== 'localhost' ||
  window.location.hostname !== '127.0.0.1'
) {
  LogRocket.init('zvveep/sow-qa', {
    network: {
      requestSanitizer,
      responseSanitizer
    },
    mergeIframes: true
  })
}

const store = getStore()
store.dispatch(Actions.createAction(Actions.APP_LAUNCHED))

function getURLParameters() {
  var sURL = window.document.URL.toString()
  var arrParams = sURL.split('?')
  if (arrParams.length > 1) {
    var arrURLParams = arrParams[1].split('&')
    var i = 0
    const extractedParams = {}
    for (i = 0; i < arrURLParams.length; i++) {
      var sParam = arrURLParams[i].split('=')
      extractedParams[sParam[0]] = sParam[1]
    }
    store.dispatch(
      Actions.createAction(Actions.SET_URL_PARAMS, {
        urlParams: extractedParams
      })
    )
  } else {
    const fullUrl = { fullUrl: sURL }
    store.dispatch(
      Actions.createAction(Actions.SET_URL_PARAMS, {
        urlParams: fullUrl
      })
    )
  }
}

if (document.cookie) {
  const cookieString = document.cookie
  if (!cookieString.includes('antidote')) {
    getURLParameters()
    document.cookie = 'antidote=antidote;'
  }
  getURLParameters()
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <StyleProvider hashPriority='low'>
        <App />
      </StyleProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
